/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, {useContext, useEffect, useRef, useState} from 'react';
import {FastField, Field, FieldArray, Form, Formik, Reset} from 'formik';
import {useHistory, useRouteMatch} from 'react-router-dom';
import * as yup from 'yup';
import Switch from 'react-switch';
import Layout from 'components/Layout';
import InputField from 'components/Form/InputField';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import Button, {ButtonContainer} from 'components/Button';
import FormContainer from 'components/FormContainer';
import Label from 'components/Form/Label';
import TextField from 'components/Form/TextField';
import {Text} from 'components/Text';
import ContentCard from 'components/ContentCard';
import _, {initial, repeat} from 'lodash';
import {AddButton, BorderSwitch, CalendarContainer, Content, Heading, PlaceHolder, TagInput} from './styles';
import {FitinsurAPI, MessageCenter} from 'utils';
import MasksHelper from 'utils/src/masks';
import Colors from 'constants/Colors';
import {DayPicker} from 'react-day-picker';
import {GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext} from 'store/context';
import Loader from 'components/Loader';
import TagsList from 'components/TagList';
import SearchField from 'components/Form/SearchField';
import ComboBox from 'components/Form/ComboBox3';
import Icon from 'components/Icon';
import Subtitle from 'components/SubTitle'

export default function CreateEnquirity(props) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const match = useRouteMatch();
  const history = useHistory();
  const [multiFields, setMultiFields] = useState({
    obligor: [],
    countryOfRisks: [],
    sicCodes: [],
    guarantors: [],
    borrowers: []
  });
  const [searchAnswers, setSearchAnswers] = useState([]);
  const [validations, setValidations] = useState({});
  const formikRef = useRef(null);
  const masks = new MasksHelper();

  const goToLoginPage = () => {
    history.push('/login');
  };

  const goToRegisterPerson = ( id) => {
    if(id != ''){
      history.push(`/save-person/${id}`);
    }else{
      history.push(`/save-person/`);
    }
  };

  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  
  const [initialV, setInitialV] = useState({
    typeOfCover: props.match.params.idProduct,
    responseBy: '',
    client: '',
    internalContact: '',
    clientDepartment: '',
    obligorCoding: '',
    broker: '',
    surplusBroker: '',
    thirdParty: '',
    leadingOffice: '',
    obligor: [{
      mainObligor: '',
      countryOfRisk: '',
      /* rating: '', */
      sicCode: '',
      idPerson: ''
    }],
    guarantor: [{
      guarantor: '',
      guarantorCountry: '',
      idPerson: ''
    }],
    borrower: [{
      borrower: '',
      borrowerCountry: '',
      idPerson: ''
    }],
    facility: [{
      facilityName: '',
      informationInterest: '',
      transactionType: '',
      currency: '',
      insuredLegalEntity: '',
      totalFacilityAmount: '',
      grossInsuredParticipation: '',
      maxLimitOfLiability: '',
      tenor: '',
      period: '',
      grossLoanMargin: 0,
      netLoanMargin: 0,
      minimumRetainedPercentage: '',
      waitingPeriod: '',
      commitmentFee: 0,
    }],
    notes: '',
    iConfirmThatAllNeededDocumentsHaveBeenReceived: false,
    highlyConfidenticial: false,
    attachments: []
  })
  
  const [brokerNameField, setBrokerNameField] = useState('');
  const [surplusBrokerNameField, setSurplusBrokerNameField] = useState('');
  const [thirdPartyNameField, setThirdPartyNameField] = useState('');
  const [camelCaseFields, setCamelCaseFields] = useState([]);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });


  useEffect(() => {
    async function request() {
      loading.start();

      if (authContext.status !== true) {
        mc.error("User is not authenticated, please Login");
        goToLoginPage();
        loading.stop();
        return;
      }
      fitinsur.setAuthToken(authContext.token);

      fitinsur.requestQuoteAdd(props.match.params.idProduct).
        then(x => x.json().then(p => {
          if (p.ret_code != 200) {
            mc.error(p.ret_msg_details);
            loading.stop();
            history.goBack()
            return;
          }
          if (p?.ret_value?.operations?.length == 0 && p?.ret_value?.payments?.length == 0 && p?.ret_value?.persons?.length == 0 && p?.ret_value?.riskQuestionnaires?.length == 0) {
            mc.error('Product configuration not found for current user.');
            loading.stop();
            history.goBack()
            return;
          }
          console.log(p);
          var q = [];
          var titles = []
          let camelJson = {};
          p.ret_value.operations.forEach(ea => {
            /* try {
              let behavior = JSON.parse(ea.behavior);
              if (behavior.isRequired) {
                let c = _.camelCase(ea.dsQuestion.replace(':', '').replace('_', ''));
                camelJson[c] = yup.string().required('*Required field');
              }

            } catch{ } */
            q.push(ea); titles.push(ea.dsQuestion)
          });
          p.ret_value.payments.forEach(ee => {
            /*  try {
               let behavior = JSON.parse(ee.behavior);
               if (behavior.isRequired) {
                 let c = _.camelCase(ee.dsQuestion.replace(':', '').replace('_', ''));
                 camelJson[c] = yup.string().required('*Required field');
               }
 
             } catch{ } */
            q.push(ee); titles.push(ee.dsQuestion)
          });
          p.ret_value.persons.forEach(ec => {
            /* try {
              let behavior = JSON.parse(ec.behavior);
              if (behavior.isRequired) {
                let c = _.camelCase(ec.dsQuestion.replace(':', '').replace('_', ''));
                camelJson[c] = yup.string().required('*Required field');
              }

            } catch{ } */
            q.push(ec); titles.push(ec.dsQuestion);
          });
          p.ret_value.risks.forEach(ed => {
            /* try {
              let behavior = JSON.parse(ed.behavior);
              if (behavior.isRequired) {
                let c = _.camelCase(ed.dsQuestion.replace(':', '').replace('_', ''));
                camelJson[c] = yup.string().required('*Required field');
              }

            } catch{ } */
            q.push(ed); titles.push(ed.dsQuestion)
          });
          console.log("todos os campos", titles);
          console.log("formated", p);
          /*  camelJson.obligor = yup.array().required().of(yup.object().shape({
             mainObligor: yup.string().required('*teste')
           }))
           setValidations(yup.object().shape(camelJson)); */
          updateContext(p);
          setQuestions(q);
          createValidation();
          /*    createValidation(); */
          fitinsur.requestProductsList().then(x => x.json()).then(res => {
            if (res.ret_code != 200) {
              return;
            }
            let e = res.ret_value.find(x => x.ID_PRODUCT == props.match.params.idProduct);
            if (e) {
              console.log(e);
              formikRef.current?.setFieldValue('typeOfCover', e.PRODUCT_NAME);
            }

          })
          loading.stop();

        })).catch(error => {
          mc.error("An error happened, please try again.");
          loading.stop();
          history.goBack()
          return;
        });



      /*  
       for (let indexR = 0; indexR < p.ret_value?.productPlans[0].questRelations.length; indexR++) {
           const element = p.ret_value?.productPlans[0].questRelations[indexR];
           for (let index = 0; index < element.questionnaire.questions.length; index++) {
              let question =  element.questionnaire.questions[index];
              question.idQuestionaire = element.questionnaire.idQuestionaire;
              question.idDomainQuestRelat = element.idDomainQuestRelat;
         
               console.log("idQuest",element.questionnaire.idQuestionaire);
               q.push(question);
               
           }
           
           
       } */
      /*  .forEach(questR => {
           questR.questionnaire.questions.forEach(question => {
               q.push(question);
           });
       }) */
      /* updateContext(p);
      console.log("INFOS",q);
      setQuestions(q); */

    }

    request();

  }, [initialV]);

  /*  const json = require('utils/src/quoteAddList.json'); */
  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => { loading.start(); resolve(reader.result) };
    reader.onerror = error => { loading.stop(); reject(error) };
  });

  const [json, updateContext] = useState({});

  /* const createValidation = () => {
    let val = yup.object().shape({
      responseBy: verifyRequired("Response by:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      client: verifyRequired("Client:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      internalContact:verifyRequired("Internal Contact:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      clientDepartment:verifyRequired("Client Department:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      obligorCoding:verifyRequired('Obligor Coding:') ? yup.string().required("* Required field") : yup.string().notRequired(),
      broker: verifyRequired('Broker') ? yup.string().required("* Required field") : yup.string().notRequired(),
      leadingOffice:verifyRequired("Leading Office:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      obligor: yup.array().of(yup.object().shape({
        mainObligor: verifyRequired("Main Obligor:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        countryOfRisk:verifyRequired("Country of Risk:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        rating:verifyRequired("Rating:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        sicCode:verifyRequired("SIC Code:") ? yup.string().required("* Required field") : yup.string().notRequired()
      })),
      guarantor: yup.array().of(yup.object().shape({
        guarantor: verifyRequired("Guarantor:")? yup.string().required("* Required field") : yup.string().notRequired(),
        guarantorCountry:verifyRequired("Guarantor Country:") ? yup.string().required("* Required field") : yup.string().notRequired()
      })),
      borrower: yup.array().of(yup.object().shape({
        borrower:verifyRequired("Borrower:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        borrowerCountry:verifyRequired("Borrower Country") ? yup.string().required("* Required field") : yup.string().notRequired()
      })),
      facility: yup.array().of(yup.object().shape({
        facilityName:verifyRequired("Facility Name:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        informationInterest:verifyRequired("Information/Interest") ? yup.string().required("* Required field") : yup.string().notRequired(),
        transactionType:verifyRequired("Transaction Type:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        currency:verifyRequired("Currency:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        insuredLegalEntity:verifyRequired("Insured Legal Entity:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        totalFacilityAmount:verifyRequired("Total Facility Amount:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        grossInsuredParticipation:verifyRequired("Gross Insured Participation:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        maxLimitOfLiability:verifyRequired("Max Limit of Liability:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        tenor:verifyRequired("Tenor:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        period:verifyRequired("Period:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        grossLoanMargin: verifyRequired("Gross Loan Margin:")? yup.string().required("* Required field") : yup.string().notRequired(),
        netLoanMargin:verifyRequired("Net Loan Margin:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        minimumRetainedPercentage: verifyRequired("Minimum Retained Percentage") ? yup.string().required("* Required field") : yup.string().notRequired(),
        waitingPeriod:verifyRequired("Waiting Period") ? yup.string().required("* Required field") : yup.string().notRequired(),
        clientField:verifyRequired("Client Field:") ? yup.string().required("* Required field") : yup.string().notRequired()
      })),

      notes: verifyRequired("Notes:") ? yup.string().required("* Required field") : yup.string().notRequired()
    });
    setValidations(val);
  } */

  const createValidation = () => {
    let val = yup.object().shape({
      responseBy: verifyRequired("Response by:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      client: verifyRequired("Client:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      internalContact: verifyRequired("Internal Contact:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      clientDepartment: verifyRequired("Client Department:") ? yup.string().required("* Required field") : yup.string().notRequired(),
      obligorCoding: verifyRequired('Obligor Coding:') ? yup.string().required("* Required field") : yup.string().notRequired(),
      broker: verifyRequired('Broker') && !isClient ? yup.string().required("* Required field") : yup.string().notRequired(),
      // surplusBroker: verifyRequired('Surplus Broker') && !isClient ? yup.string().required("* Required field") : yup.string().notRequired(),
      // thirdParty: verifyRequired('3rd Party') && !isClient ? yup.string().required("* Required field") : yup.string().notRequired(),
      leadingOffice: verifyRequired("Leading Office:") && !isClient ? yup.string().required("* Required field") : yup.string().notRequired(),
      obligor: yup.array().of(yup.object().shape({
        mainObligor: verifyRequired("Main Obligor:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        countryOfRisk: verifyRequired("Country of Risk:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        sicCode: verifyRequired("SIC Code:") ? yup.string().required("* Required field") : yup.string().notRequired()

      })),
      guarantor: yup.array().of(yup.object().shape({
        guarantor: verifyRequired("Guarantor:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        guarantorCountry: yup.string().when("guarantor", (guar, guarCountry) => !guar ? guarCountry : guarCountry.required('* Required field'))
      })),
      borrower: yup.array().of(yup.object().shape({
        borrower: verifyRequired("Borrower:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        borrowerCountry: yup.string().when("borrower", (borr, borrCountry) => !borr ? borrCountry : borrCountry.required('* Required field'))
      })),
      facility: yup.array().of(yup.object().shape({
        facilityName: yup.string().required("* Required field"),
        informationInterest: verifyRequired("Information/Interest") ? yup.string().required("* Required field") : yup.string().notRequired(),
        transactionType: verifyRequired("Transaction Type:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        currency: verifyRequired("Currency:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        insuredLegalEntity: verifyRequired("Insured Legal Entity:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        totalFacilityAmount: verifyRequired("Total Facility Amount:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        grossInsuredParticipation: yup.mixed().required('* Required field').when("totalFacilityAmount", (totalFacility, grossInsured) => 
          grossInsured.test("more than", "* Must be lower or equal than Total Facility Amount", gross => Number(gross?.replaceAll(",", "").replaceAll(".", "")) <= Number(totalFacility?.replaceAll(",", "").replaceAll(".", "")))),
        maxLimitOfLiability: yup.mixed().required('* Required field').when("grossInsuredParticipation", (grossInsured, maxLimit) => 
          maxLimit.test("more than", "* Must be lower or equal than Gross Insured Participation", max => Number(max?.replaceAll(",", "").replaceAll(".", "")) <= Number(grossInsured?.replaceAll(",", "").replaceAll(".", "")))),
        tenor: verifyRequired("Tenor:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        period: verifyRequired("Period:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        grossLoanMargin: verifyRequired("Gross Loan Margin:") ? yup.string().required("* Required field") : yup.string().notRequired(),
        netLoanMargin: yup.mixed().when("grossLoanMargin", (grossLoan, netLoan) => {
            return netLoan.test("more than", "* Must be lower or equal than Gross Loan Margin", net => {
              return  net?.length >= 1 
                ? Number(net?.split("%")[1]) <= Number(grossLoan?.split("%")[1])
                : true
              }) 
        }),
        minimumRetainedPercentage: verifyRequired("Minimum Retained Percentage") ? yup.string().required("* Required field") : yup.string().notRequired(),
        waitingPeriod: verifyRequired("Waiting Period") ? yup.string().required("* Required field") : yup.string().notRequired(),
        commitmentFee: verifyRequired("Commitment Fee") ? yup.string().required("* Required field") : yup.string().notRequired(),
      })),
      notes: verifyRequired("Notes:") ? yup.string().required("* Required field") : yup.string().notRequired()
    });
    setValidations(val);
  }

  const searchRequest = (e, fieldName) => {
    if (fieldName != 'Broker' && !e) {
     
      if (fieldName != 'Insured Legal Entity:' && !e) {
        setSearchList([]);
        return;
      }
     
    }

    try {
     
      let id;
      let body;
      if (fieldName == 'Client:') {
        id = "fitQueryPersonClient";
        body = {
          personName: e,
          idOperationParent: props.match.params.idOperationParent
        }
      }
      else if (fieldName == 'Insured Legal Entity:') {
        const client = searchAnswers.find(x => x.questionName == 'Client:');
        id = "fitGetCompanyPerson";
        body = {
          idPerson: client.answerJson.id || '',
          personName: e || ''
        }
      }
      else if (fieldName == 'Broker') {
        
        const client = searchAnswers.find(x => x.questionName == 'Client:');

        id = "fitGetPersonBrokerByClient";
        body = {
          idPerson: client.answerJson.id || '',
          personName: e || ''
        }
       
        if(body.personName == ''){
          body.personName = brokerNameField;
         
        }

       } else if (fieldName == 'Surplus Broker:') {        
          id = "fitGetPersonSurplusBroker";
          body = {
            personName: e || ''
          }
       
          if (body.personName == '') {
            body.personName = surplusBrokerNameField;
          }
        }else if (fieldName == '3rd Party:') {
            id = "fitGetPersonThirdParty";
            body = {
              personName: e || ''
            }
            
            if (body.personName == '') {
              body.personName = thirdPartyNameField;
            }
      } else {
        let question = questions.find(item => item.dsQuestion === fieldName);
        
        if (question) {
          question = JSON.parse(question.behavior);
          id = question.searchQueryId;
          body = {}
          body[question.searchQueryFieldText] = e;
        } else {
          
          /* id = "fitQueryPerson";
          id = "fitGetJuridicPerson";
          body = {
            personName: e
          } */
            id = "fitGetCompanyPerson"; 
            body = {
            personName: e 
            }
            console.log("DEBUG-DENISE:");
            console.log(fieldName);
            console.log(id);
            console.log(body);
            console.log(question);
        }

      }

      fitinsur.setAuthToken(authContext.token);
      console.log("DEBUG - requestPersonList - id:"+id);
      console.log("DEBUG - requestPersonList - body:"+JSON.stringify(body));      
      fitinsur.requestPersonList(id, body)
        .then((response) => { return response.json() })
        .then((data) => {
          if (data.ret_code != 200) {
            return;
          }
          if (fieldName == 'Broker') {
            let list = [];
            data.ret_value.forEach(x => {
              x.id = x.idPersonUser
              x.personName = `${x.nmPersonBroker}`
              list.push(x);
              
            })
            setSearchList(list);
            return;
          }

          console.log(data);
          setSearchList(data.ret_value);
        });
      //console.log("resultado ret_Value: ", response);
      console.log("Search state Value: ", e);
      console.log("O que quero: ", brokerNameField);
    } catch (err) {
      console.log("FETCH_FAILURE: ", err);
    }

  }


  //old format
  /* const formatResponse = (e) => {
      let bodyQ = [];

      for (let index = 0; index < json.ret_value?.questRelations.length; index++) {
          const questRelations = json.ret_value?.questRelations[index];
          for (let index = 0; index < questRelations.questionnaire.questions.length; index++) {
              let add = true;
              const question = questRelations.questionnaire
              bodyQ.forEach(obj => {
                  if (obj.idQuestionaire == question.idQuestionaire)
                      add = false;

              })

              if (add) {
                  bodyQ.push({
                      idQuestionaire: question.idQuestionaire,
                      idOpsQuestRelat: questRelations.idOpsQuestRelat,
                      idDomainQuestionaire: question.idDomainQuestionaire,
                      questions: []
                  });
              }

          }

      }

      json.ret_value.productPlans[0].questRelations.forEach(element => {
          bodyQ.push({
              idQuestionaire: element.questionnaire.idQuestionaire,
              idDomainQuestionaire: element.questionnaire.idDomainQuestionaire,
              questions: []
          });
      });

      console.log('cleanArray', e);

      let r = []
      const paths = [e.borrower, e.guarantor, e.facility, e.obligor];
      paths.forEach(o => o.forEach(or => r.push(or)));
      let formatedR = [];
      r.forEach((t) => {
          let rf = Object.keys(t).map((key) => [key, t[key]]);
          rf.forEach(objr => formatedR.push(objr));
      })

      let answeredQuestion = 0;

      questions.forEach(lQ => {
          let qi = lQ.dsQuestion.toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase();
          formatedR.forEach(fRes => {
              let resF = fRes[0].toString().replace('_', '').replace(/\s/g, '').toLowerCase();
              console.log("lQ",qi);
              console.log("fres",resF );
              if (resF == qi && fRes[1]) {
                  console.log("Pergunta:" + lQ.dsQuestion);
                  console.log("Resposta:" + fRes[1]);
                  console.log("idQuestionnaire", lQ.idQuestionaire);
                  console.log("idQuestRelation:" + lQ.idDomainQuestRelat);
                  answeredQuestion++;
                  bodyQ.forEach(questionaires => {
                      if (questionaires.idQuestionaire == lQ.idQuestionaire) {
                          questionaires.questions.push({
                              idQuestion: lQ.idQuestion,
                              idDomainQuestion: lQ.idDomainQuestion,
                              idDomainTypeQuestion: lQ.idDomainTypeQuestion,
                              idDomainPersonRoleQuestion: lQ.idDomainPersonRoleQuestion,
                              idDomainTypePersonRoleQuestion: lQ.idDomainTypePersonRoleQuestion,

                              behaviorQuestion: lQ.behavior,
                              answer: typeof fRes[1] === "string" ? fRes[1] : fRes[1].idAnswerOption,
                              idAnswerOption: typeof fRes[1] === "object" ? fRes[1].idAnswerOption : null
                          });
                      }
                  })
              }
          })
      })
      console.log("answeredQuestions", answeredQuestion);
      return bodyQ;
  }
*/

  const returnQuestion = (a, b, response = null, responseObject = false, index = 0) => {
    //console.log('jhonny', questions, a, b, response, responseObject,index, '\n\n\n');
    let formatedR = [];
    let rf = Object.keys(b).map((key) => [key, b[key]]);
    rf.forEach(objr => formatedR.push(objr));
    console.log(formatedR);
    let answer = formatedR.find(x => x[0].toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase() == a.toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase());
    console.log(answer);
    if (response || typeof (response) == 'boolean') {
      let qstT = questions.find(x => x.dsQuestion.toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase() == a.toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase());
      if (qstT) {
        let qst = { ...qstT }

        if (typeof (response) === 'string') {
          let search = searchAnswers.find(x => (x.questionName == a && x.index == index))
          if (search) {
            qst.answerJson = JSON.stringify({ ...search.answerJson });
          }
          qst.answer = response;
          delete qst['idAnswerOption'];
          delete qst['answerOptions'];
        }
        else if (typeof (response) === 'boolean') {

          qst.idAnswerOption = response ? qst.answerOptions.find(x => x.dsAnswerOption == "YES").idAnswerOption : qst.answerOptions.find(x => x.dsAnswerOption == "NO").idAnswerOption;
          qst.answer = response ? qst.answerOptions.find(x => x.dsAnswerOption == "YES").dsAnswerOption : qst.answerOptions.find(x => x.dsAnswerOption == "NO").dsAnswerOption;
        }
        else if (responseObject) {
          qst.answer = response;
          delete qst['idAnswerOption'];
          delete qst['answerOptions'];
        } else {
          qst.idAnswerOption = response.idAnswerOption;
          qst.answer = qst.answerOptions.find(x => x.idAnswerOption == qst.idAnswerOption).dsAnswerOption || qst.idAnswerOption;
        }
        if ("answerOptions" in qst) {
          delete qst['answerOptions'];
        }
        if ("behavior" in qst) {
          delete qst['behavior'];
        }
        return qst;
      } else {
        return '';
      }

    }
    else if (answer) {
      let questionT = questions.find(x => x.dsQuestion.toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase() == answer[0].toString().replace('_', '').replace(':', '').replace(/\s/g, '').toLowerCase());
      if (questionT) {
        let question = { ...questionT }

        if (!answer[1] && typeof (answer[1]) != 'boolean') {
          return "";
        }
        if (typeof (answer[1]) === 'string') {
          question.answer = answer[1];
          let search = searchAnswers.find(x => (x.questionName == a && x.index == index))
          if (search) {
            question.answerJson = JSON.stringify({ ...search.answerJson });
          }
          delete question['idAnswerOption'];
          delete question['answerOptions'];
        }
        else if (typeof (answer[1]) === 'boolean') {
          if (answer[1] == null) {
            return '';
          }
          question.idAnswerOption = answer[1] ? question.answerOptions.find(x => x.dsAnswerOption == "YES").idAnswerOption : question.answerOptions.find(x => x.dsAnswerOption == "NO").idAnswerOption;
          question.answer = response ? question.answerOptions.find(x => x.dsAnswerOption == "YES").dsAnswerOption : question.answerOptions.find(x => x.dsAnswerOption == "NO").dsAnswerOption;
        } else {
          question.idAnswerOption = answer[1].idAnswerOption;
          question.answer = question.answerOptions.find(x => x.idAnswerOption == question.idAnswerOption).dsAnswerOption || question.idAnswerOption;

        }
        if ("answerOptions" in question) {
          delete question['answerOptions'];
        }
        if ("behavior" in question) {
          delete question['behavior'];
        }
        return question
      } else {
        return '';
      }
    } else {
      return '';
    }


  }

  const handleSubmit = (e) => {

    console.log(e);
    console.log('campo combo', returnQuestion('Currency:', e.facility[0]))
    let personFields = ["Type of Cover:", "Response by:", "Client Department:", "Obligor Coding:"];
    let operations = ["Broker", 'Leading Office:', 'Highly Confidenticial', 'Surplus Broker', '3rd Party:', 'Notes:']
    let client = returnQuestion('Client:', e);
    if (!client) {
      mc.error("'Client' field is required.");
      return;
    }
    let ic = returnQuestion('Internal Contact:', e);
    client.otherFields = []
    personFields.forEach(pF => {
      let opf = returnQuestion(pF, e, null, false, 0);
      if (opf != '') {
        client.otherFields.push({ ...opf });
      }
    })
    if (ic != '') {
      client.contact = {
        idDomainContact: 282,
        answer: ic.answer,
        idQuestionaire: ic.idQuestionaire,
        idQuestion: ic.idQuestion
      }

    }

    let body = {
      create: true,
      idTemplate: 1,
      idProduct: props.match.params.idProduct,
      idDomainOperation: 26,
      idDomainTypeOperation: 9,
      persons: [client],
      operationsQuestionnaire: [],
      riskQuestionnaire: {
        groupings: []
      }
    }
    
    let fieldSpaceValidation = true;

    const facilityNames = e.facility.map(facility => {
      let verify = facility.facilityName.trim();
      if(verify == ''){
        fieldSpaceValidation = false;
      }else{
      return verify;
      }
      })
    
    if(fieldSpaceValidation === false){
      mc.error(`Facility name should be filled`);
      return;
    }

    let nonRepeatedFacilityNames =  [...new Set(facilityNames)];

    if (nonRepeatedFacilityNames.length < facilityNames.length) {
      mc.error("Facility name should be unique");
      return;
    }

    e.obligor.forEach((obligorE, index) => {
      if (obligorE.mainObligor) {
        let mObligor = returnQuestion('Main Obligor:', obligorE, obligorE.mainObligor, false, index);
        if (mObligor) {
          let of = [];
          if (obligorE.countryOfRisk) {
            let cr = returnQuestion('Country of Risk:', obligorE, obligorE.countryOfRisk, false, index);
            if (cr) {
              of.push({ ...cr });
            }
          }
          /* if (obligorE.countryOfRisk) {
            let r = returnQuestion('Rating:', obligorE, obligorE.rating, false, index);
            if (r) {
              of.push({ ...r });
            }
          } */
          if (obligorE.countryOfRisk) {
            let sc = returnQuestion('Sic Code:', obligorE, obligorE.sicCode, false, index);
            if (sc) {
              of.push({ ...sc });
            }
          }
          if (of.length >= 1) {
            mObligor.otherFields = of;
          }
          body.persons.push({ ...mObligor });
        }

      } else {
        mc.error("'Main Obligor' field is required.");
        return;
      }
    })

    e.borrower.forEach((borrowerE, index) => {
      if (borrowerE?.borrower) {
        let borrowerObj = returnQuestion('Borrower:', e.borrower, borrowerE.borrower, false, index);
        if (borrowerObj) {
          let of = [];
          if (borrowerE.borrowerCountry) {
            let bc = returnQuestion('Borrower Country', borrowerE, borrowerE.borrowerCountry, false, index);
            if (bc) {
              of.push({ ...bc });
            }
          }
          if (of.length >= 1) {
            borrowerObj.otherFields = of;
          }
          body.persons.push({ ...borrowerObj });
        }
      }

    });

    e.guarantor.forEach((guarantorE, index) => {
      if (guarantorE?.guarantor) {
        let guarantorObj = returnQuestion('Guarantor:', e.guarantor, guarantorE.guarantor, false, index);
        if (guarantorObj) {
          let of = [];
          if (guarantorE.guarantorCountry) {
            let gc = returnQuestion('Guarantor Country', guarantorE, guarantorE.guarantorCountry, false, index);
            if (gc) {
              of.push({ ...gc });
            }
          }
          if (of.length >= 1) {
            guarantorObj.otherFields = of;
          }
          body.persons.push({ ...guarantorObj });
        }
      }

    });


    e.facility.forEach((riskSession, index) => {
      let risk = []
      if (riskSession.facilityName) {
        let fN = returnQuestion('Facility Name:', riskSession, riskSession.facilityName.trim(), false, index);
        if (fN) {
          risk.push({ ...fN });
        }
      }
      if (riskSession.informationInterest) {
        let iI = returnQuestion('Information/Interest', riskSession, riskSession.informationInterest, false, index);
        if (iI) {
          risk.push({ ...iI });
        }
      }
      if (riskSession.transactionType) {
        let tT = returnQuestion('Transaction Type:', riskSession, riskSession.transactionType, false, index);
        if (tT) {
          risk.push({ ...tT });
        }
      }
      if (riskSession.currency) {
        let c = returnQuestion('Currency:', riskSession, riskSession.currency, false, index);
        if (c) {
          risk.push({ ...c });
        }
      }
      if (riskSession.insuredLegalEntity) {
        let eL = returnQuestion('Insured Legal Entity:', riskSession, riskSession.insuredLegalEntity, false, index);
        if (eL) {
          risk.push({ ...eL });
        }
      }
      if (riskSession.totalFacilityAmount) {
        let tF = returnQuestion('Total Facility Amount:', riskSession, riskSession.totalFacilityAmount, false, index);
        if (tF) {
          risk.push({ ...tF });
        }
      }
      if (riskSession.grossInsuredParticipation) {
        let gI = returnQuestion('Gross Insured Participation:', riskSession, riskSession.grossInsuredParticipation, false, index);
        if (gI) {
          risk.push({ ...gI });
        }
      }
      if (riskSession.maxLimitOfLiability) {
        let mL = returnQuestion('Max Limit of Liability:', riskSession, riskSession.maxLimitOfLiability, false, index);
        if (mL) {
          risk.push({ ...mL });
        }
      }
      if (riskSession.tenor) {
        let t = returnQuestion('Tenor:', riskSession, riskSession.tenor, false, index);
        if (t) {
          risk.push({ ...t });
        }
      }
      if (riskSession.period) {
        let p = returnQuestion('Period:', riskSession, riskSession.period, false, index);
        if (p) {
          risk.push({ ...p });
        }
      }
      if (riskSession.grossLoanMargin) {
        let gL = returnQuestion('Gross Loan Margin:', riskSession, riskSession.grossLoanMargin, false, index);
        if (gL) {
          risk.push({ ...gL });
        }
      }
      if (riskSession.netLoanMargin) {
        let nL = returnQuestion('Net Loan Margin:', riskSession, riskSession.netLoanMargin, false, index);
        if (nL) {
          risk.push({ ...nL });
        }
      }
      if (riskSession.minimumRetainedPercentage) {
        let mRP = returnQuestion("Minimum Retained Percentage", riskSession, riskSession.minimumRetainedPercentage, false, index);
        if (mRP) {
          risk.push({ ...mRP });
        }
      }
      if (riskSession.waitingPeriod) {
        let wP = returnQuestion("Waiting Period", riskSession, riskSession.waitingPeriod, false, index);
        if (wP) {
          risk.push({ ...wP });
        }
      }
      if (riskSession.commitmentFee) {
        let cF = returnQuestion('Commitment Fee', riskSession, riskSession.commitmentFee, false, index);
        if (cF) {
          risk.push({ ...cF });
        }
      }
      if (risk) {
        let obj = { risks: risk };
        body.riskQuestionnaire.groupings.push({ ...obj });
      }

    })

    operations.forEach(oF => {
      let opf = returnQuestion(oF, e, null, false, 0);
      if (opf != '') {
        if (oF === 'Surplus Broker'|| oF === '3rd Party:') {
          body.persons.push({ ...opf });
        } else {
          body.operationsQuestionnaire.push({ ...opf });
        }
      }
    })


    let bodyAttach = {
      "create": true,
      "operationsQuestionnaire": []
    }

    e.attachments.forEach(attach => {
      let docType = returnQuestion('Document Type:', e, attach.documentType);
      let att = returnQuestion('Attachments:', e, 'file', true);
      let newFile = {
        isFile: true,
        idQuestion: att.idQuestion,
        idQuestionaire: att.idQuestionaire,
        file: {
          fileName: attach.fileName,
          size: attach.size,
          fileBase64: attach.fileBase64,
          documentType: {
            idAnswerOption: docType.idAnswerOption,
            dsAnswerOption: docType.answer
          }
        }
      }
      att.isFile = true;
      att.file = attach;
      bodyAttach.operationsQuestionnaire.push(newFile);
    })
    console.log(bodyAttach);

    /*  e.attachments.forEach(attach => {
         body.operationsQuestionnaire.push({ ...returnQuestion('Document Type:', e, attach.documentType) });
         let att = returnQuestion('Attachments:', e, 'file', true)
         att.isFile = true;
         att.file = attach;
         body.operationsQuestionnaire.push({ ...att });
     }) */

    body.idOperationParent = props.match.params.idOperationParent;
    body.operationsQuestionnaire.push({ ...returnQuestion("I confirm that all needed documents have been received.", e, e.iConfirmThatAllNeededDocumentsHaveBeenReceived) });
    console.log(JSON.stringify(body));
    console.log(body);
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestQuoteSubmit(body)
      .then(res => res.json()).then(response => {
        console.log(response);
        if (response.ret_code == 200) {
          if (e.attachments.length > 0) {
            bodyAttach.idOperation = response.ret_value;
            fitinsur.updateAttachmentOperation(bodyAttach).then(x => x.json).then(res => {
              console.log(res);
              loading.stop();
              history.push('/list');
            });
          } else {
            loading.stop();
            history.push('/list');
          }
        } else {
          mc.error(response.ret_msg_details);
          loading.stop();
        }
      }).catch((a) => { loading.stop(); });


    // old, preciso reformular
    /* let body = {
        create: true,
        idProduct: json.ret_value.idProduct,
        idDomainOperation: 26,
        idDomainTypeOperation: 9,
        questionnaires: formatResponse(e),

    }
    console.log(body); */
    /* console.log("Submit Evento -> ", e);
    console.log("Arquivos -> ", arrayFile);
    console.log("QuoteADD-> ", questions);
    console.log(questions.map(item => item.dsQuestion));
    console.log(json);
    console.log(fields);
    console.log("TESTE QUESTIONS",questions);
    
    console.log(b);*/



  }


  const [file, setFile] = useState(undefined);

  const [showCalendar, setCalendar] = useState(false);
  const [arrayFile, setArrayFile] = useState([]);
  const [questions, setQuestions] = useState([]);


  useEffect(() => {
    console.log('MULTIFIELDS', multiFields);
    CountFields();
    if (questions.length >= 1) {
      createValidation();
    }


  }, [questions]);

  const rightIconClick = () => {
    setCalendar(!showCalendar);
  }

  const setDocuments = e => {
    setArrayFile(e.currentTarget.files);
    console.log(arrayFile);
  }

  const fieldRenderOptions = function (answerOptions) {
    let result = []
    answerOptions.forEach(element => {

      result.push({
        label: element.dsAnswerOption,
        value: {
          idAnswerOption: element.idAnswerOption,
          dsAnswerOption: element.dsAnswerOption
        }
      });
    });
    return result;
  }



  const [fields, setFields] = useState({
    broker: 0,
    surplusBroker: 0,
    thirdParty: 0,
    obligor: 0,
    guarantor: 0,
    borrower: 0,
    facility: 0,
    attachments: 0,
    cardless: 0
  })


  const [showFields, setShowFields] = useState({
    obligor: true,
    facility: true,
    broker: true,
    surplusBroker: true,
    thirdParty: true,
    guarantor: true,
    borrower: true,
    attachments: true
  });

  /*  useEffect(()=>{
     
       if (!questions) {
           return;
       }
       console.log("faci", fields.facility > 0)
       setShowFields({facility: fields.facility > 0})
   },[fields]); */

  const pessoa = ["Type of Cover:", 'Response by:', 'Client:', 'Internal Contact:', 'Client Department:', 'obligorCoding:']
  const broker = ["Highly Confidenticial", 'Leading Office', 'Broker:']
  const surplusBroker = [ "Surplus Broker:"]
  const thirdParty = [ "3rd Party:"]
  const obligor = ["Main Obligor:", "Country of Risk:", /* "Rating:", */ "SIC Code:"]
  const guarantor = ["Guarantor:"]
  const borrower = ['Borrower:']
  const facility = ['Facility Name:', 'Transaction Type:', 'Currency:', 'Total Facility Amount:', 'Insured Legal Entity:', "Gross Insured Participation:", "Max Limit of Liability:", 'Commitment Fee', 'Tenor:', 'Net Loan Margin:', 'Gross Loan Margin:', 'Period:']
  const attachments = ["Document Type:", 'Document Attached:', "I confirm that all needed documents have been received."]

  const CountFields = () => {
    let obj = fields;

    let types = ['Broker:', 'Surplus Broker:', '3rd Party:', 'Client Department:', "Document Type:", 'Document Attached:', "I confirm that all needed documents have been received.", 'Notes:', "Highly Confidenticial", "Main Obligor:", "Country of Risk:", /* "Rating:", */ "SIC Code:", "Guarantor:", 'Borrower:', 'Facility Name:', 'Transaction Type:', 'Currency:', 'Total Facility Amount:', 'Insured Legal Entity:', "Gross Insured Participation:", "Max Limit of Liability:", 'Commitment Fee', 'Tenor:', 'Net Loan Margin:', 'Gross Loan Margin:', 'Period:'];
    /* types.concat(broker);
    types.concat(obligor);
    types.concat(guarantor);
    types.concat(borrower);
    types.concat(facility);
    types.concat(attachments); */
    console.log('types', types);

    types.forEach(p => {

      const field = questions?.find(f => f.dsQuestion == p);
      console.log('campo', field)
      if (!field) {
        return;
      }

      let t = typeofFieldName(p);
      switch (t) {
        case "broker":
          obj.broker++;
          break;
        case "surplusBroker":
          obj.surplusBroker++;
          break;
        case "thirdParty":
          obj.thirdParty++;
          break;     
        case "obligor":
          obj.obligor++;
          break;
        case "guarantor":
          obj.guarantor++;
          break;
        case "borrower":
          obj.borrower++;
          break;
        case "facility":
          obj.facility++;
          break;
        case "attachments":
          obj.attachments++;
          break;
        default:
          obj.cardless++;
          break;

      }

    })
    setFields(obj);
    console.log('t', fields.facility);
    console.log('d', fields.facility > 0)
    setShowFields({
      obligor: fields.obligor > 0,
      facility: fields.facility > 0,
      broker: fields.broker > 0,
      surplusBroker: fields.surplusBroker > 0,
      thirdParty: fields.thirdParty > 0,
      guarantor: fields.guarantor > 0,
      borrower: fields.borrower > 0,
      attachments: fields.attachments > 0
    });

  }

  const typeofFieldName = (fieldName) => {

    if (broker.find(f => f == fieldName)) {
      return "broker";
    }
    if (surplusBroker.find(f => f == fieldName)) {
      return "surplusBroker";
    }
    if (thirdParty.find(f => f == fieldName)) {
      return "thirdParty";
    }
    if (obligor.find(f => f == fieldName)) {
      return "obligor";
    }
    if (guarantor.find(f => f == fieldName)) {
      return "guarantor";
    }
    if (borrower.find(f => f == fieldName)) {
      return "borrower";
    }
    if (facility.find(f => f == fieldName)) {
      return "facility";
    }
    if (attachments.find(f => f == fieldName)) {
      return "attachments";
    }
  }




  const verifyField = (fieldName) => {

    if (!questions) {
      return;
    }
    /* let relate = {};
    let found = false;
    for (let indexR = 0; indexR < json.ret_value?.productPlans[0].questRelations.length; indexR++) {
        const element = json.ret_value?.productPlans[0].questRelations[indexR];
        let found2 = false;
        for (let index = 0; index < element.questionnaire.questions.length; index++) {

            let question =  element.questionnaire.questions[index].dsQuestion;
            
            if(question == fieldName){
              relate.fieldName = question;
              relate.idDomainQuestRelat = element.idDomainQuestRelat;
              relate.idQuestionaire = element.questionnaire.idQuestionaire
              found = true;
              found2 = true;
              break;
            }
           
            
            
            
        }
        if(found2){
            break;
        }
        
        
    }
   
 
    if (found) { 
        let list = formFields;
        list.push(relate);
        setFormFields(list)
        console.log(formFields)
        return true;
    } */
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      return true;
    }
    return false;
  }

  const verifyComponent = (fieldName) => {
    if (!questions) {
      return;
    }
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      if (question.idDomainQuestion === 42) {
        return InputField;
      } else if (question.idDomainQuestion == 43) {
        return /* SelectField */ComboBox;
      } else if (question.idDomainQuestion === 276) {
        return SearchField;
      } else if (question.idDomainQuestion === 295) {
        return InputField;
      } else if (question.idDomainQuestion === 277) {
        return InputField;
      }
  }
}
  

  const verifyVisiblity = (fieldName) => {
   
    if (!questions) {
    
      return;
    }
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      if (question?.visibleQuestion) {
        return question.visibleQuestion == 1 ? false : true;
      }
      return true;

    }
    return true;
  }

  const verifyRequired = (fieldName) => {
    if (!questions) {
      return false;
    }
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      if (question?.behavior) {
        try {
          let e = JSON.parse(question.behavior);
          return e.isRequired;
        } catch{ return false; };
        
      }
      return false;

    }
    return false;
  }

  const verifyRegexPattern = (fieldName) => {
    if (!questions) {
      return '';
    }
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      if (question?.behavior) {
        try {
          let e = JSON.parse(question.behavior);
          /* return e.fieldMask || ''; */
          return undefined;
        } catch { return ''; };
      }
      return '';

    }
    return '';
  }

  const verifyPattern = (fieldName) => {
    if (!questions) {
      return null;
    }
    const question = questions.find(item => item.dsQuestion === fieldName);
    if (question) {
      if (question?.behavior) {
        try {
          let e = JSON.parse(question.behavior);
          if (e.fieldMask) {
            let m;
            if (e.fieldMask == "percentage") {
              m = masks.getPercentage(authContext.region,e.fieldMaskScale || null, e.fieldMaxValue || "9999", e.fieldMinValue || "0");
            }else{
              m = masks.getMask(e.fieldMask || null, authContext.region, e.fieldMaskScale || null,e.fieldMaskLength || null,e.fieldMaxValue || null, e.fieldMinValue || null)
            }
            return m;
          }
          return null;
         
        } catch { return null; };
      }
      return null;

    }
    return null;
  }

  const verifyOptions = (fieldName, fieldID) => {
    if (!questions) {
      return;
    }
    const field = questions.find(f => f.dsQuestion == fieldName);
    if (field) {
     

      if (field.answerOptions) {
        return fieldRenderOptions(field.answerOptions);
      } else {
        return null;
      }
    }

  }

  const setSearch = (questionName, index, response = false) => {
    let list = [...searchAnswers];
    let ex = list?.find(x => (x.questionName == questionName && x.index == index))
    if (typeof (response) == 'boolean' && !response && ex) {
      list.splice(_.indexOf(list, ex), 1);
      setSearchAnswers(list);
      return;
    }
    if (typeof (response) == 'boolean') return;
    if (ex) {
      ex.answerJson = response;
      setSearchAnswers(list);

      return;
    }
    list.push({
      questionName: questionName,
      index: index,
      answerJson: response
    })
    setSearchAnswers(list);
  

  }


  const [searchList, setSearchList] = useState([]);

  /* 
    useEffect(()=>{
      formik.current.resetForm();
    },[initialV]) */



  //const handleUploadFile = (e) => setCardFile(e.target.files[0]);

  //ToDo retirar as linhas e ajustar em colunas
  return (
    <Layout title={props.match.params.idOperationParent ? 'New Enquiry – Declaration' : "New Enquiry"}>

      {/* <Row style={{ paddingTop: "15px" }}>
                <Col>
                    <LayoutCircle isActive={true}>1 </LayoutCircle>
                    <Text spaceLeft={true}>LOGGING</Text>
                </Col>
                <Col>
                    <LayoutCircle isActive={false}>2</LayoutCircle>
                    <Text spaceLeft={true}>BROKING</Text>
                </Col>
                <Col>
                    <LayoutCircle isActive={false}>3</LayoutCircle>
                    <Text spaceLeft={true}>BINDING</Text>
                </Col>
            </Row> */}
      <Subtitle stage={1}></Subtitle>
        <ContentCard title="Summary">
          <Formik
            innerRef={formikRef}
            initialValues={initialV}
            enableReinitialize={true}
            /* initialValues={{ typeOfCover: props.match.params.idProduct, notes: '', iConfirmThatAllNeededDocumentsHaveBeenReceived: false, highlyConfidenticial: false, obligor: [{}], guarantor: [{}], borrower: [{}], facility: [{}], attachments: [] }} */
            onSubmit={(values) => handleSubmit(values)}
            validationSchema={validations}

            render={({ values, setFieldValue, resetForm }) => (
              <Form>


                {/* <SearchField

                                    onChange={e => e.target.value}

                                /> */}

                <Row>
                  <Col>

                  </Col>
                  <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Text onClick={() => { /* formikRef.current?.setFieldValue('typeOfCover', "teeeeeeeeeeeeeeeeeeeeeeeeeeeesste"); console.log('SEARCH', formikRef); */ }} >*Required Fields</Text>
                    <button onClick={(e) => { e.stopPropagation(); e.preventDefault() }} style={{ opacity: 0, width: 0, height: 0 }}></button>
                  </Col>

                </Row>

                <Row style={{ paddingLeft: 15, paddingRight: 15 }}>

                  {verifyField("Type of Cover:") ?
                    <Col md={4}>
                      <Field
                        label="Type of Cover"
                        name={'typeOfCover'}
                        type="text"
                        value={values.typeOfCover}
                        readOnly
                        component={verifyComponent("Type of Cover:")}
                        options={verifyOptions("Type of Cover:")}
                        searchList={searchList}
                        onChange={(e) => {
                          setSearch("Type of Cover:", 0);
                          setFieldValue('typeOfCover', e);
                          if (!values.typeOfCover || verifyComponent("Type of Cover:") != SearchField) {
                            return;
                          }
                          searchRequest(e, "Type of Cover:");

                        }}
                        onFocus={(e) => {
                          setSearchList([]);
                        }}
                        onSearchSelect={(e) => {
                          setSearch("Type of Cover:", 0, e);
                          setSearchList([]);
                        }}

                      />
                    </Col>
                    : ''}
                  {verifyField('Response by:') ?
                    <Col hidden={verifyVisiblity("Response by:")} md={4}>
                      <Field
                        name="responseBy"
                        mask={verifyPattern("Response by:")}
                        isRequired={verifyRequired("Response by:")}
                        value={values.responseBy}
                        label="Response by"
                        rightIcon="calendar"
                        rightIconClick={rightIconClick}
                        type="text"
                        readOnly
                        component={verifyComponent('Response by:')}



                      ></Field>

                      {showCalendar ?
                        <CalendarContainer>
                          <DayPicker style
                            disabledDays={[
                              {
                                before: new Date()
                              }
                            ]}
                            fixedWeeks
                            onDayClick={(t) => { setFieldValue('responseBy', new Date(t) ? new Date(t) <= new Date() ? new Date().toLocaleDateString('en-GB') : new Date(t).toLocaleDateString('en-GB') : null); setCalendar(false); }}
                          ></DayPicker>
                        </CalendarContainer>
                        : null}
                    </Col>
                    : ''}
                  {verifyField('Client:') ?
                    <Col hidden={verifyVisiblity("Client:")} md={4}>
                      <Field
                        mask={verifyPattern("Client:")}

                        isRequired={verifyRequired("Client:")}
                        name={'client'}
                        label="Client"
                        type="text"
                        value={values.client}
                        searchList={searchList}
                        canGenerate={false}
                        onChange={(e) => {
                          setSearch("Client:", 0);

                          setFieldValue('client', e);
                          values.facility.forEach((element, index) => {
                            setFieldValue(`facility.${index}.insuredLegalEntity`, '')

                            setSearch("Insured Legal Entity:", index);
                          });
                          setFieldValue(`broker`, '')
                          setSearch("Broker", 0);

                          if (!values.client || verifyComponent('Client:') != SearchField) {
                            return;
                          }
                          searchRequest(e, "Client:");

                        }}
                        onFocus={(e) => {
                          setSearchList([]);

                        }}
                        onSearchSelect={(e) => {
                          setSearch("Client:", 0, e);
                          setSearchList([]);
                        }}

                        component={verifyComponent('Client:')}
                        options={verifyOptions('Client:')}
                      />
                    </Col>
                    : ''}
                </Row>
                <Row style={{ paddingLeft: 15, paddingRight: 15, marginBottom: -25 }} >
                  {verifyField('Internal Contact:') ?
                    <Col hidden={verifyVisiblity("Internal Contact:")} md={4}>
                      <Field
                        mask={verifyPattern("Internal Contact:")}

                        isRequired={verifyRequired("Internal Contact:")}
                        name={'internalContact'}
                        label="Internal Contact"
                        type="text"
                        component={verifyComponent('Internal Contact:')}
                        options={verifyOptions('Internal Contact:')}
                        value={values.internalContact}
                        searchList={searchList}
                        onChange={(e) => {
                          setSearch("Internal Contact:", 0);
                          setFieldValue('internalContact', e);
                          if (!values.internalContact || verifyComponent('Internal Contact:') != SearchField) {
                            return;
                          }
                          searchRequest(e, "Internal Contact:");

                        }}
                        onFocus={(e) => {
                          setSearchList([]);
                        }}
                        onSearchSelect={(e) => {
                          setSearch("Internal Contact:", 0, e);
                          setSearchList([]);
                        }}


                      />
                    </Col>
                    : ''}

                  {verifyField('Client Department:') ?
                    <Col hidden={verifyVisiblity("Client Department:")} md={4}>
                      <Field
                        mask={verifyPattern("Client Department:")}

                        isRequired={verifyRequired("Client Department:")}
                        name={'clientDepartment'}
                        label="Client Department"
                        type="text"
                        component={verifyComponent('Client Department:')}
                        options={verifyOptions('Client Department:')}
                        value={values.clientDepartment}
                        searchList={searchList}
                        onChange={(e) => {
                          setSearch("Client Departament:", 0);
                          setFieldValue('clientDepartment', e);
                          if (!values.clientDepartment || verifyComponent('Client Department:') != SearchField) {
                            return;
                          }
                          searchRequest(e, "Client Department:");

                        }}
                        onFocus={(e) => {
                          setSearchList([]);
                        }}
                        onSearchSelect={(e) => {
                          setSearch("Client Departament:", 0, e);
                          setSearchList([]);
                        }}

                      />
                    </Col>
                    : ''}

                  {verifyField("Obligor Coding:") ?
                    <Col hidden={verifyVisiblity('Obligor Coding:')} md={4}>
                      <Field
                        mask={verifyPattern('Obligor Coding:')}


                        isRequired={verifyRequired('Obligor Coding:')}

                        name={'obligorCoding'}
                        label="Obligor Coding"
                        type="text"
                        component={verifyComponent('Obligor Coding:')}
                        options={verifyOptions('Obligor Coding:')}
                        value={values.obligorCoding}
                        searchList={searchList}
                        onChange={(e) => {

                          setFieldValue('obligorCoding', e);
                          if (!values.obligorCoding || verifyComponent('Obligor Coding:') != SearchField) {
                            return;
                          }
                          setSearch("Obligor Coding:", 0);
                          searchRequest(e, "Obligor Coding:");

                        }}
                        onFocus={(e) => {
                          setSearchList([]);
                        }}
                        onSearchSelect={(e) => {
                          setSearch("Obligor Coding:", 0, e);
                          setSearchList([]);
                        }}

                      />
                    </Col>
                    : ''}
                </Row>

                {showFields.broker && !isClient ? <>
                  <FormContainer show={true} title="BROKING AND ACCOUNT INFORMATION">
                    <Row>
                      {verifyField('Broker') ?
                        <Col hidden={verifyVisiblity('Broker')} md={5}>
                          <Field 

                            mask={verifyPattern('Broker')}

                            isRequired={verifyRequired('Broker')}
                            name={'broker'}
                            label="Broker"
                            type="text"
                            readOnly={values.client ? false : true}
                            placeholder={values.client ? '' : 'Waiting for Client'}
                            component={verifyComponent('Broker')}
                            options={verifyOptions('Broker')}
                            value={values.broker}
                            searchList={searchList}
                            onChange={(e) => {
                              setBrokerNameField(e);
                              setSearch('Broker', 0);
                              setFieldValue(`broker`, e);
                              if (!values.broker || verifyComponent('Broker') != SearchField) {
                                return;
                              }
                              if(e.length <= 1){
                                searchRequest(" ", 'Broker');
                                
                              }else{
                                searchRequest(e, 'Broker');
                              }
                            }}
                            onFocus={(e) => {
                              searchRequest("", 'Broker');
                            }}
                            onSearchSelect={(e) => {
                              setSearch('Broker', 0, e);
                              setSearchList([]);
                            }}
                            onBlur={(e) => {
                              if(searchAnswers[1]){
                                  console.log("Search Answers "+searchAnswers[1].answerJson.personName);
                                  console.log('earch Answers',e);

                                  
                                }else{

                                  if (searchList.length == 1){
                                    setFieldValue('broker', searchList[0].personName)
                                    setBrokerNameField(searchList[0].personName)
                                  }else{
                                  }
                                  setSearch('Broker', 0);
                                  let a;
                                  if(searchList.length > 1){
                                    
                                    searchList.forEach(x => {
                                      if(x.personName.toUpperCase() == e.toUpperCase()){
                                        a = true;
                                      }else{
                                        a = false;
                                      }
                                      
                                    })
                                  }
                                  if(a == false){
                                    setFieldValue('broker', '')
                                    mc.error("'Select a Broker.");
                                  }
                                  if(searchList.length == 0){
                                    setFieldValue('broker', '')
                                    /* mc.error("'Select a Broker."); */
                                    mc.error("'Broker' field the name entered does not exist.");
                                  }
                                  setSearchList([]);

                                }
                                
                                }}
                                
                              
                              /* onChange={(e) => {
                                setSearch("Broker", 0);
                                setFieldValue('broker', e);
                                if (!values.broker || verifyComponent('Broker') != SearchField) {
                                  return;
                                }
                                searchRequest(e, "Broker");
                                
                              }}
                              onFocus={(e) => {
                                setSearchList([]);
                              }}
                              onSearchSelect={(e) => {
                                setSearch("Broker", 0, e);
                                setSearchList([]);
                              }} */
                              />
                              </Col>
                        : ''}
                      {verifyField("Leading Office:") ?
                        <Col hidden={verifyVisiblity("Leading Office:")} md={5}>
                          <Field
                            mask={verifyPattern("Leading Office:")}

                            isRequired={verifyRequired("Leading Office:")}
                            name={'leadingOffice'}
                            label="Leading Office"
                            type="text"
                            component={verifyComponent("Leading Office:")}
                            options={verifyOptions("Leading Office:")}
                            value={values.leadingOffice}
                            searchList={searchList}
                            onChange={(e) => {
                              setSearch("Leading Office:", 0);
                              setFieldValue('leadingOffice', e);
                              if (!values.leadingOffice || verifyComponent('Leading Office:') != SearchField) {
                                return;
                              }
                              searchRequest(e, "Leading Office:");

                            }}
                            onFocus={(e) => {
                              setSearchList([]);
                            }}
                            onSearchSelect={(e) => {
                              setSearch("Leading Office:", 0, e);
                              setSearchList([]);
                            }}
                          />
                        </Col>
                        : ''}
                      {verifyField("Highly Confidenticial") ?
                        <Col hidden={verifyVisiblity("Highly Confidenticial")} md={2}>
                          <Label>{"Highly Confidenticial"}</Label>
                          {/* <Icon name="cadeado" className='cadeado' ></Icon> */}
                          <BorderSwitch>
                            <Switch
                              height={27}
                              width={53}
                              checked={values.highlyConfidenticial}
                              onChange={(a) => { setFieldValue("highlyConfidenticial", a) }}
                              handleDiameter={20}
                              checkedIcon={false}
                              uncheckedIcon={false}
                              offColor={Colors.WHITE}
                              onColor={Colors.GRAY[6]}
                              offHandleColor={Colors.GRAY[6]}
                              onHandleColor={Colors.WHITE}
                            />
                          </BorderSwitch>
                        </Col>
                        : ''}
                    </Row>
                    <Row>
                    {verifyField('Surplus Broker:') ?
                        <Col hidden={verifyVisiblity('Surplus Broker:')} md={5}>
                          <Field 
                            mask={verifyPattern('Surplus Broker')}
                            isRequired={verifyRequired('Surplus Broker')}
                            name={'Surplus Broker:'}
                            label="Surplus Broker"
                            type="text"
                            component={verifyComponent('Surplus Broker:')}
                            options={verifyOptions('Surplus Broker:')}
                            value={values.surplusBroker}
                            searchList={searchList}
                            onChange={(e) => {
                              setSurplusBrokerNameField(e);
                              setSearch('Surplus Broker:', 0);
                              setFieldValue(`surplusBroker`, e);
                              if (!values.surplusBroker || verifyComponent('Surplus Broker:') != SearchField) {
                                return;
                              }
                              searchRequest(e, 'Surplus Broker:');
                            }}
                            onFocus={(e) => {
                              searchRequest("", 'Surplus Broker:');
                            }}
                            onSearchSelect={(e) => {
                              setSearch('Surplus Broker', 0, e);
                              setSearchList([]);
                            }}
                          />
                          </Col>
                        : ''}
                       {verifyField("3rd Party:") ?
                         <Col hidden={verifyVisiblity('3rd Party:')} md={5}>
                         <Field 

                           mask={verifyPattern('3rd Party:')}

                           isRequired={verifyRequired('3rd Party:')}
                           name={'3rd Party:'}
                           label="3rd Party"
                           type="text"
                           component={verifyComponent('3rd Party:')}
                           options={verifyOptions('3rd Party:')}
                           value={values.thirdParty}
                           searchList={searchList}
                           onChange={(e) => {
                             setThirdPartyNameField(e);
                             setSearch('3rd Party:', 0);
                             setFieldValue(`thirdParty`, e);
                             if (!values.thirdParty || verifyComponent('3rd Party:') != SearchField) {
                               return;
                             }
                             searchRequest(e, '3rd Party:');
                           }}
                           onFocus={(e) => {
                             searchRequest("", '3rd Party:');
                           }}
                           onSearchSelect={(e) => {
                             setSearch('3rd Party:', 0, e);
                             setSearchList([]);
                           }}
                        />
                        </Col>
                        : ''} 
                    </Row>
                  </FormContainer>

                </> : null}

                {showFields.obligor ? <>
                  <FormContainer show={true} title="OBLIGOR">

                    <FieldArray
                      name="obligor"

                      render={arrayHelpers => (
                        <>
                          {values.obligor && values.obligor.length > 0 ?
                            (
                              values.obligor.map((obligor, index) => (
                                <>
                                  <div key={`opt-obligor-${index}`}></div>
                                  <Row>
                                    {verifyField("Main Obligor:") ?
                                      <Col hidden={verifyVisiblity("Main Obligor:")} md={6} style={{paddingRight : 0}}>
                                        <Field
                                          mask={verifyPattern("Main Obligor:")}

                                          isRequired={verifyRequired("Main Obligor:")}
                                          name={`obligor.${index}.mainObligor`}
                                          label={index === 0 ? "Main Obligor" : "Obligor"}
                                          type="text"
                                          component={verifyComponent("Main Obligor:")}
                                          options={verifyOptions("Main Obligor:")}

                                          value={values.obligor[index]?.mainObligor}
                                          searchList={searchList}
                                          onChange={(e) => {
                                            setSearch("Main Obligor:", index);
                                            setFieldValue(`obligor.${index}.mainObligor`, e);
                                            setFieldValue(`obligor.${index}.sicCodeStatus`, '');
                                            if (!values.obligor[index]?.mainObligor || verifyComponent('Main Obligor:') != SearchField) {
                                              return;
                                            }
                                            searchRequest(e, "Main Obligor:");

                                          }}
                                          onFocus={(e) => {
                                            setSearchList([]);
                                          }}
                                          onSearchSelect={(e) => {
                                            setSearch("Main Obligor:", index, e);
                                            console.log(e);
                                            setSearchList([]);
                                            setFieldValue(`obligor.${index}.sicCodeStatus`, 'true');
                                            fitinsur.setAuthToken(authContext.token);
                                            fitinsur.requestSicCode(e.id).then(x => x.json().then(response => {
                                              if (response.ret_code != 200) {
                                                setFieldValue(`obligor.${index}.sicCodeStatus`, '');
                                                return;
                                              }
                                              if (response.ret_value) {
                                                let res = response.ret_value;
                                                if (res.codSic && res.descSic) {

                                                  setFieldValue(`obligor.${index}.sicCode`, { idAnswerOption: res.codSic, dsAnswerOption: res.descSic, id:e.id });
                                                  setFieldValue(`obligor.${index}.idPerson`, { id:e.id })
                                                } else {
                                                  setFieldValue(`obligor.${index}.sicCodeStatus`, '');
                                                }

                                              } else {
                                                setFieldValue(`obligor.${index}.sicCodeStatus`, '');
                                              }
                                            })).catch(() => { setFieldValue(`obligor.${index}.sicCodeStatus`, ''); })
                                          }}
                                        />
                                      </Col>
                                      : ''}
                                      <Col md={1} style={{ justifyContent: "space-between", alignItems: "center", display: "flex", paddingLeft: 0 }}>
                                        <AddButton onClick={(e) => { 
                                          goToRegisterPerson(obligor.idPerson.id? obligor.idPerson.id : ''); }}>
                                          <Icon name="addEdit"></Icon>
                                        </AddButton>
                                      </Col>
                                      <Col hidden={true}>
                                        <Field
                                          name={`obligor.${index}.idPerson`}
                                          value={values.obligor[index]?.idPerson}
                                        />
                                        </Col>
                                    {verifyField("Country of Risk:") ?
                                      <Col hidden={verifyVisiblity("Country of Risk:")} md={5}>
                                        <Field
                                          mask={verifyPattern("Country of Risk:")}

                                          isRequired={verifyRequired("Country of Risk:")}
                                          name={`obligor.${index}.countryOfRisk`}
                                          label={"Country of Risk"}
                                          type="text"
                                          component={verifyComponent("Country of Risk:")}
                                          options={verifyOptions("Country of Risk:")}

                                          value={values.obligor[index]?.countryOfRisk}
                                          searchList={searchList}
                                          onChange={(e) => {
                                            setSearch("Country of Risk:", index);
                                            setFieldValue(`obligor.${index}.countryOfRisk`, e);
                                            if (!values.obligor[index]?.countryOfRisk || verifyComponent('Country of Risk:') != SearchField) {
                                              return;
                                            }
                                            searchRequest(e, "Country of Risk:");

                                          }}
                                          onFocus={(e) => {
                                            setSearchList([]);
                                          }}
                                          onSearchSelect={(e) => {
                                            setSearch("Country of Risk:", index, e);
                                            setSearchList([]);
                                          }}
                                        />
                                      </Col>
                                      : ''}

                                    {/* {index === 0 ?
                                    verifyField('Rating:') ?
                                      <Col hidden={verifyVisiblity("Rating:")} md={2}>
                                        <Field
                                          mask={verifyPattern("Rating:")}
             
                                          isRequired={verifyRequired("Rating:")}
                                          name={`obligor.${index}.rating`}
                                          label="Rating"
                                          type="text"
                                          component={verifyComponent("Rating:")}
                                          options={verifyOptions('Rating:')}

                                          value={values.obligor[index]?.rating}
                                          searchList={searchList}
                                          onChange={(e) => {
                                            setSearch("Rating:", index);
                                            setFieldValue(`obligor.${index}.rating`, e);
                                            if (!values.obligor[index]?.rating || verifyComponent('Rating:') != SearchField) {
                                              return;
                                            }
                                            searchRequest(e, 'Rating:');

                                          }}
                                          onFocus={(e) => {
                                            setSearchList([]);
                                          }}
                                          onSearchSelect={(e) => {
                                            setSearch("Rating:", index, e);
                                            setSearchList([]);
                                          }}
                                        />
                                      </Col>
                                      : ''
                                    : ''} */}
                                  </Row>
                                  <Row>
                                    <Col hidden={verifyVisiblity("SIC Code:")} md={11}>
                                      {verifyField("SIC Code:") ?
                                        <Field
                                          mask={verifyPattern("SIC Code:")}
                                          isRequired={verifyRequired("SIC Code:")}
                                          name={`obligor.${index}.sicCode`}
                                          label="Sic Code"
                                          type="text"
                                          component={verifyComponent("SIC Code:")}
                                          options={verifyOptions('SIC Code:')}
                                          disabled={values.obligor[index]?.sicCodeStatus == 'true' ? true : false}
                                          value={values.obligor[index]?.sicCode}
                                          searchList={searchList}
                                          onChange={(e) => {
                                            setSearch("SIC Code:", index);
                                            setFieldValue(`obligor.${index}.sicCode`, e);
                                            if (!values.obligor[index]?.sicCode || verifyComponent('SIC Code:') != SearchField) {
                                              return;
                                            }
                                            searchRequest(e, "SIC Code:");

                                          }}
                                          onFocus={(e) => {
                                            setSearchList([]);
                                          }}
                                          onSearchSelect={(e) => {
                                            setSearch("SIC Code:", index, e);
                                            setSearchList([]);
                                          }}
                                        />


                                        : ''}
                                      {verifyField('SIC Code:') ? <input style={{ visibility: 'hidden', height: 0, width: 0 }} value={values.obligor[index]?.sicCodeStatus} name={`obligor.${index}.sicCodeStatus`}></input> : ''}

                                    </Col>

                                    {values.obligor.length > 1 ?

                                      <Col md={1} style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                        {index === 0 ? <></> :
                                          <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.remove(index); }}>
                                            <Icon name="trash"></Icon>
                                          </AddButton>
                                        }
                                        {index != values.obligor.length - 1 ? <></> :
                                          <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.push({ mainObligor: "", countryOfRisk: "", sicCode: "" }); }}>
                                            <Icon name="plus"></Icon>
                                          </AddButton>
                                        }
                                      </Col>

                                      :
                                      <Col md={1} style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                        <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.push({ mainObligor: "", countryOfRisk: "", sicCode: "" }); }}>
                                          <Icon name="plus"></Icon>
                                        </AddButton>
                                      </Col>


                                    }

                                  </Row>

                                </>

                              ))
                            ) : <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.push({ mainObligor: "", countryOfRisk: "", sicCode: "" }); }}>
                              <Icon name="plus"></Icon>
                            </AddButton>
                          }
                        </>
                      )}
                    />
                  </FormContainer>


                </> : null}

                {showFields.guarantor ? <>
                  <FormContainer show={true} title="GUARANTOR">

                    <FieldArray
                      name="guarantor"
                      render={arrayHelpers => (
                        <>
                          {values.guarantor && values.guarantor.length > 0 ?
                            (
                              values.guarantor.map((guarantor, index) => (
                                <>
                                  <div key={`opt-guarantor-${index}`}></div>
                                  <Row>
                                    {verifyField('Guarantor:') ?
                                      <>
                                        <Col md={6} hidden={verifyVisiblity("Guarantor:")} style={{paddingRight : 0}}>
                                          <Field
                                            mask={verifyPattern("Guarantor:")}

                                            isRequired={verifyRequired("Guarantor:")}
                                            name={`guarantor.${index}.guarantor`}
                                            label="Guarantor"
                                            type="text"
                                            component={verifyComponent('Guarantor:')}
                                            options={verifyOptions('Guarantor:')}
                                            value={values.guarantor[index]?.guarantor}
                                            searchList={searchList}
                                            onChange={(e) => {
                                              setSearch("Guarantor:", index);
                                              setFieldValue(`guarantor.${index}.guarantor`, e);
                                              if (!values.guarantor[index]?.guarantor || verifyComponent('Guarantor:') != SearchField) {
                                                return;
                                              }
                                              searchRequest(e, "Guarantor:");

                                            }}
                                            onFocus={(e) => {
                                              setSearchList([]);
                                            }}
                                            onSearchSelect={(e) => {
                                              setSearch("Guarantor:", index, e);
                                              setFieldValue(`guarantor.${index}.idPerson`, { id:e.id })
                                              setSearchList([]);
                                            }}
                                          />
                                        </Col>
                                        <Col md={1} style={{ justifyContent: "space-between", alignItems: "center", display: "flex", paddingLeft: 0 }}>
                                        <AddButton onClick={(e) => { 
                                          goToRegisterPerson(guarantor.idPerson.id? guarantor.idPerson.id : ''); }}>
                                          <Icon name="addEdit"></Icon>
                                        </AddButton>
                                      </Col>
                                        <Col md={4} hidden={verifyVisiblity("Guarantor Country:")}>
                                          <Field
                                            mask={verifyPattern("Guarantor Country:")}

                                            isRequired={verifyRequired("Guarantor Country:")}
                                            name={`guarantor.${index}.guarantorCountry`}
                                            label="Country"
                                            type="text"
                                            component={verifyComponent('Guarantor Country:')}
                                            options={verifyOptions('Guarantor Country:')}
                                            value={values.guarantor[index]?.guarantorCountry}
                                            searchList={searchList}
                                            onChange={(e) => {
                                              setSearch("Guarantor Country:", index);
                                              setFieldValue(`guarantor.${index}.guarantorCountry`, e);
                                              if (!values.guarantor[index]?.guarantorCountry || verifyComponent('Guarantor Country:') != SearchField) {
                                                return;
                                              }
                                              searchRequest(e, "Guarantor Country:");

                                            }}
                                            onFocus={(e) => {
                                              setSearchList([]);
                                            }}
                                            onSearchSelect={(e) => {
                                              setSearch("Guarantor Country:", index, e);
                                              setSearchList([]);
                                            }}
                                          />
                                        </Col>
                                        <Col md={1} style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                          {index === 0 ? <></> :
                                            <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.remove(index) }}>
                                              <Icon name="trash"></Icon>
                                            </AddButton>
                                          }
                                          {index != values.guarantor.length - 1 ? <></> :
                                            <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.push({ guarantor: '', guarantorCountry: '' }) }}>
                                              <Icon name="plus"></Icon>
                                            </AddButton>
                                          }
                                        </Col>
                                      </>
                                      : ''}
                                  </Row>
                                </>

                              ))
                            ) : <AddButton onClick={() => { arrayHelpers.push({ guarantor: '', guarantorCountry: '' }) }}>
                              <Icon name="plus"></Icon>
                            </AddButton>
                          }
                        </>
                      )}
                    />
                  </FormContainer>

                </> : null}

                {showFields.borrower ? <> <FormContainer show={true} title="BORROWER">
                  <FieldArray
                    name={"borrower"}
                    render={arrayHelpers => (
                      <>
                        {values.borrower && values.borrower.length > 0 ?
                          (
                            values.borrower.map((borrower, index) => (
                              <>
                                <div key={`opt-borrower-${index}`}></div>
                                <Row>
                                  {verifyField('Borrower:') ?
                                    <>
                                      <Col md={6} hidden={verifyVisiblity("Borrower:")} style={{paddingRight : 0}}>
                                        <Field
                                          mask={verifyPattern("Borrower:")}

                                          isRequired={verifyRequired("Borrower:")}
                                          name={`borrower.${index}.borrower`}
                                          label="Borrower"
                                          type="text"
                                          component={verifyComponent('Borrower:')}
                                          options={verifyOptions('Borrower:')}
                                          value={values.borrower[index]?.borrower}
                                          searchList={searchList}
                                          onChange={(e) => {
                                            setSearch("Borrower:", index);
                                            setFieldValue(`borrower.${index}.borrower`, e);
                                            if (!values.borrower[index]?.borrower || verifyComponent('Borrower:') != SearchField) {
                                              return;
                                            }
                                            searchRequest(e, "Borrower:");

                                          }}
                                          onFocus={(e) => {
                                            setSearchList([]);
                                          }}
                                          onSearchSelect={(e) => {
                                            setSearch("Borrower:", index, e);
                                            setFieldValue(`borrower.${index}.idPerson`, { id:e.id })
                                            setSearchList([]);
                                          }}
                                        />

                                      </Col>
                                        <Col md={1} style={{ justifyContent: "space-between", alignItems: "center", display: "flex", paddingLeft: 0 }}>
                                          <AddButton onClick={(e) => { 
                                            goToRegisterPerson(borrower.idPerson.id? borrower.idPerson.id : ''); }}>
                                            <Icon name="addEdit"></Icon>
                                          </AddButton>
                                        </Col>
                                      <Col md={4} hidden={verifyVisiblity("Borrower Country")}>
                                        <Field
                                          mask={verifyPattern("Borrower Country")}

                                          isRequired={verifyRequired("Borrower Country")}
                                          name={`borrower.${index}.borrowerCountry`}
                                          label="Country"
                                          type="text"
                                          component={verifyComponent("Borrower Country")}
                                          options={verifyOptions("Borrower Country")}
                                          value={values.borrower[index]?.borrowerCountry}
                                          searchList={searchList}
                                          onChange={(e) => {
                                            setSearch("Borrower Country", index);
                                            setFieldValue(`borrower.${index}.borrowerCountry`, e);
                                            if (!values.borrower[index]?.borrowerCountry || verifyComponent("Borrower Country") != SearchField) {
                                              return;
                                            }
                                            searchRequest(e, "Borrower Country");

                                          }}
                                          onFocus={(e) => {
                                            setSearchList([]);
                                          }}
                                          onSearchSelect={(e) => {
                                            setSearch("Borrower Country", index, e);
                                            setSearchList([]);
                                          }}
                                        />


                                      </Col>
                                      <Col md={1} style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                        {index === 0 ? <></> :
                                          <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.remove(index) }}>
                                            <Icon name="trash"></Icon>
                                          </AddButton>
                                        }
                                        {index != values.borrower.length - 1 ? <></> :
                                          <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.push({ borrower: '', borrowerCountry: '' }) }}>
                                            <Icon name="plus"></Icon>
                                          </AddButton>
                                        }
                                      </Col>
                                    </>
                                    : ''}
                                </Row>
                              </>

                            ))
                          ) : <AddButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); arrayHelpers.push({ borrower: '', borrowerCountry: '' }) }}>
                            <Icon name="plus"></Icon>
                          </AddButton>
                        }
                      </>
                    )}
                  />
                </FormContainer>

                </> : null}


                {showFields.facility ?
                  <>


                      <FieldArray
                        name="facility"
                        render={arrayHelpers => (
                          <>
                            {values.facility && values.facility.length > 0 ?
                              (
                                values.facility.map((facility, index) => {
                                  return (
                                    <FormContainer show={true} title={index < 1? "MAIN CONTRACT" : `FACILITY ${index}`}>
                                    <>
                                      <div key={`opt-facility-${index}`}>
                                        <Row>
                                          <Col hidden={verifyVisiblity("Facility Name:")}>
                                            {verifyField('Facility Name:') ?
                                              <Field
                                                mask={verifyPattern("Facility Name:")}

                                                isRequired={verifyRequired("Facility Name:")}
                                                name={`facility.${index}.facilityName`}
                                                label="Facility Name"
                                                type="text"
                                                component={verifyComponent('Facility Name:')}
                                                value={values.facility[index]?.facilityName}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Facility Name:", index);
                                                  setFieldValue(`facility.${index}.facilityName`, e);
                                                  if (!values.facility[index]?.facilityName || verifyComponent('Facility Name:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Facility Name:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Facility Name:", index, e);
                                                  setSearchList([]);
                                                }}
                                              />

                                              : ''}
                                          </Col>
                                        </Row>
                                        <Row>

                                          {verifyField("Information/Interest") ?
                                            <Col /* style={{ marginLeft: 10, marginRight: 10, marginBottom: 16 }} */>
                                              <FastField
                                                name={`facility.${index}.informationInterest`}
                                                label="Information/Interest"
                                                type="text"
                                                isRequired={verifyRequired("Information/Interest")}
                                                value={values.facility[index].informationInterest}
                                                onChange={e => {

                                                  setFieldValue(`facility.${index}.informationInterest`, e);
                                                }}
                                                component={TextField}

                                              />
                                            </Col>
                                            : ''
                                          }
                                        </Row>
                                        <Row>
                                          {verifyField('Transaction Type:') ?
                                            <Col hidden={verifyVisiblity("Transaction Type:")}>
                                              <Field
                                                name={`facility.${index}.transactionType`}
                                                label="Transaction Type"
                                                mask={verifyPattern("Transaction Type:")}

                                                isRequired={verifyRequired("Transaction Type:")}
                                                component={verifyComponent('Transaction Type:')}
                                                options={verifyOptions('Transaction Type:')}
                                                value={values.facility[index]?.transactionType}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Transaction Type:", index);
                                                  setFieldValue(`facility.${index}.transactionType`, e);
                                                  if (!values.facility[index]?.transactionType || verifyComponent('Transaction Type:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Transaction Type:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Transaction Type:", index, e);
                                                  setSearchList([]);
                                                }}
                                              />
                                            </Col>
                                            : ''}
                                          {verifyField('Currency:') ?
                                            <Col hidden={verifyVisiblity("Currency:")}>
                                              <Field
                                                name={`facility.${index}.currency`}
                                                label="Currency"
                                                mask={verifyPattern("Currency:")}

                                                isRequired={verifyRequired("Currency:")}
                                                component={verifyComponent('Currency:')}
                                                options={verifyOptions('Currency:')}
                                                value={values.facility[index]?.currency}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Currency:", index);
                                                  setFieldValue(`facility.${index}.currency`, e);
                                                  if (!values.facility[index]?.currency || verifyComponent('Currency:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Currency:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Currency:", index, e);
                                                  setSearchList([]);
                                                }}
                                              >
                                              </Field>
                                            </Col>
                                            : ''}
                                          {verifyField('Insured Legal Entity:') ? <>
                                            <Col hidden={verifyVisiblity("Insured Legal Entity:")}>
                                              <Field
                                                mask={verifyPattern("Insured Legal Entity:")}
                                                isRequired={verifyRequired("Insured Legal Entity:")}
                                                name={`facility.${index}.insuredLegalEntity`}
                                                label="Insured Legal Entity"

                                                readOnly={values.client ? false : true}
                                                placeholder={values.client ? '' : 'Waiting for Client'}
                                                component={verifyComponent('Insured Legal Entity:')}
                                                options={verifyOptions('Insured Legal Entity:')}
                                                canGenerate={false}
                                                value={values.facility[index]?.insuredLegalEntity}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Insured Legal Entity:", index);
                                                  setFieldValue(`facility.${index}.insuredLegalEntity`, e);
                                                  console.log('Primeiro valor',values.facility[index]?.insuredLegalEntity)
                                                  if (!values.facility[index]?.insuredLegalEntity || verifyComponent('Insured Legal Entity:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, 'Insured Legal Entity:');

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                  searchRequest("", 'Insured Legal Entity:');
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Insured Legal Entity:", index, e);
                                                  setSearchList([]);
                                                }}
                                              >
                                              </Field>
                                            </Col>
                                            </> 
                                            : ''}
                                        </Row>
                                        <Row>
                                          {verifyField('Total Facility Amount:') ?
                                            <Col hidden={verifyVisiblity("Total Facility Amount:")}>
                                              <Field
                                                mask={verifyPattern("Total Facility Amount:") }
                                                isRequired={verifyRequired("Total Facility Amount:")}
                                                name={`facility.${index}.totalFacilityAmount`}
                                                label="Total Facility Amount"
                                                type="text"
                                                component={verifyComponent('Total Facility Amount:')}
                                                options={verifyOptions('Total Facility Amount:')}
                                                value={values.facility[index]?.totalFacilityAmount}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Total Facility Amount:", index);
                                                  setFieldValue(`facility.${index}.totalFacilityAmount`, e);
                                                  if (!values.facility[index]?.totalFacilityAmount || verifyComponent('Total Facility Amount:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, 'Total Facility Amount:');

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Total Facility Amount:", index, e);
                                                  setSearchList([]);
                                                }}
                                              />
                                            </Col>
                                            : ''}
                                          {verifyField("Gross Insured Participation:") ?
                                            <Col hidden={verifyVisiblity("Gross Insured Participation:")}>
                                              <Field
                                                mask={verifyPattern("Gross Insured Participation:")}
                                                isRequired={verifyRequired("Gross Insured Participation:")}
                                                name={`facility.${index}.grossInsuredParticipation`}
                                                label="Gross Insured Participation"
                                                type="text"
                                                component={verifyComponent("Gross Insured Participation:")}
                                                options={verifyOptions("Gross Insured Participation:")}

                                                value={values.facility[index]?.grossInsuredParticipation}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Gross Insured Participation:", index);
                                                  setFieldValue(`facility.${index}.grossInsuredParticipation`, e);
                                                  if (!values.facility[index]?.grossInsuredParticipation || verifyComponent('Gross Insured Participation:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Gross Insured Participation:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Gross Insured Participation:", index, e);
                                                  setSearchList([]);
                                                }}
                                              />
                                            </Col>
                                            : ''}
                                          {verifyField("Max Limit of Liability:") ?
                                            <Col hidden={verifyVisiblity("Max Limit of Liability:")}>
                                              <Field
                                                mask={verifyPattern("Max Limit of Liability:")}
                                                isRequired={verifyRequired("Max Limit of Liability:")}
                                                name={`facility.${index}.maxLimitOfLiability`}
                                                label="Max Limit of Liability"
                                                type="text"
                                                component={verifyComponent("Max Limit of Liability:")}
                                                options={verifyOptions("Max Limit of Liability:")}

                                                value={values.facility[index]?.maxLimitOfLiability}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Max Limit of Liability:", index);
                                                  setFieldValue(`facility.${index}.maxLimitOfLiability`, e);
                                                  if (!values.facility[index]?.maxLimitOfLiability || verifyComponent('Max Limit of Liability:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Max Limit of Liability:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Max Limit of Liability:", index, e);
                                                  setSearchList([]);
                                                }}
                                              />
                                            </Col>
                                            : ''}
                                        </Row>
                                        <Row>
                                          {verifyField('Tenor:') ?
                                            <Col hidden={verifyVisiblity("Tenor:")} md={1}>
                                              <Field
                                                mask={verifyPattern("Tenor:")}
                                                isRequired={verifyRequired("Tenor:")}
                                                name={`facility.${index}.tenor`}
                                                label="Tenor"
                                                type="text"
                                                component={verifyComponent('Tenor:')}
                                                options={verifyOptions('Tenor:')}
                                                value={values.facility[index]?.tenor}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  if(e.includes("-") || isNaN(Number(e))) {
                                                    setFieldValue(`facility.${index}.tenor`, values.facility[index]?.tenor);
                                                    return;
                                                  }

                                                  setSearch("Tenor:", index);
                                                  setFieldValue(`facility.${index}.tenor`, e);
                                                  if (!values.facility[index]?.tenor || verifyComponent('Tenor:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Tenor:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Tenor:", index, e);
                                                  setSearchList([]);
                                                }}
                                              />
                                            </Col>
                                            : ''}
                                          {verifyField('Period:') ?
                                            <Col hidden={verifyVisiblity("Period:")} md={3}>
                                              <Field
                                                mask={verifyPattern("Period:")}

                                                isRequired={verifyRequired("Period:")}
                                                name={`facility.${index}.period`}
                                                label="Period"

                                                component={verifyComponent('Period:')}
                                                options={verifyOptions('Period:')}
                                                value={values.facility[index]?.period}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch('Period:', index);
                                                  setFieldValue(`facility.${index}.period`, e);
                                                  if (!values.facility[index]?.period || verifyComponent('Period:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Period:");

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch('Period:', index, e);
                                                  setSearchList([]);
                                                }}
                                              >
                                              </Field>
                                            </Col>
                                            : ''}
                                          {verifyField('Gross Loan Margin:') ?
                                            <Col hidden={verifyVisiblity("Gross Loan Margin:")} md={4}>
                                              <Field
                                                mask={verifyPattern("Gross Loan Margin:")}

                                                isRequired={verifyRequired("Gross Loan Margin:")}
                                                name={`facility.${index}.grossLoanMargin`}
                                                label="Gross Loan Margin"
                                                type="text"
                                                component={verifyComponent('Gross Loan Margin:')}
                                                options={verifyOptions('Gross Loan Margin:')}
                                                value={values.facility[index]?.grossLoanMargin}
                                                searchList={searchList}

                                                onChange={(e) => {
                                                  setSearch("Gross Loan Margin:", index);
                                                  setFieldValue(`facility.${index}.grossLoanMargin`, e || 0);
                                                  if (!values.facility[index]?.grossLoanMargin || verifyComponent('Gross Loan Margin:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, 'Gross Loan Margin:');
                                                  
                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Gross Loan Margin:", index, e);
                                                  setSearchList([]);
                                                }}
                                                /* isRequired */
                                                />
                                            </Col>
                                            : ''}
                                          {verifyField('Net Loan Margin:') ?
                                            <Col hidden={verifyVisiblity("Net Loan Margin:")}>
                                              <Field
                                                mask={verifyPattern("Net Loan Margin:")}

                                                isRequired={verifyRequired("Net Loan Margin:")}
                                                name={`facility.${index}.netLoanMargin`}
                                                label="Net Loan Margin"
                                                type="text"
                                                component={verifyComponent('Net Loan Margin:')}
                                                options={verifyOptions('Net Loan Margin:')}
                                                value={values.facility[index]?.netLoanMargin}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Net Loan Margin:", index);
                                                  setFieldValue(`facility.${index}.netLoanMargin`, e || 0);
                                                  if (!values.facility[index]?.netLoanMargin || verifyComponent('Net Loan Margin:') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, 'Net Loan Margin:');

                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Net Loan Margin:", index, e);
                                                  setSearchList([]);
                                                }}
                                              /* isRequired */
                                              />
                                            </Col>
                                            : ''}
                                        </Row>
                                        <Row>
                                          <Col md={4} hidden={verifyVisiblity("Minimum Retained Percentage")}>
                                            <Field
                                              type="text"
                                              label="Minimum Retained Percentage"
                                              name={`facility.${index}.minimumRetainedPercentage`}
                                              mask={verifyPattern("Minimum Retained Percentage")}
                                              isRequired={verifyRequired("Minimum Retained Percentage")}
                                              component={verifyComponent("Minimum Retained Percentage")}
                                              options={verifyOptions("Minimum Retained Percentage")}
                                              value={values.facility[index]?.minimumRetainedPercentage}
                                              searchList={searchList}
                                              onChange={(e) => {
                                                setSearch("Minimum Retained Percentage", index);
                                                setFieldValue(`facility.${index}.minimumRetainedPercentage`, e);
                                                if (!values.facility[index]?.minimumRetainedPercentage || verifyComponent('Minimum Retained Percentage') != SearchField) {
                                                  return;
                                                }
                                                searchRequest(e, "Minimum Retained Percentage");
                                              }}
                                              onFocus={(e) => {
                                                setSearchList([]);
                                              }}
                                              onSearchSelect={(e) => {
                                                setSearch("Minimum Retained Percentage", index, e);
                                                setSearchList([]);
                                              }}
                                            />
                                          </Col>
                                          <Col md={4} hidden={verifyVisiblity("Waiting Period")}>
                                            <Field
                                              type="text"
                                              label="Waiting Period (Days)"
                                              name={`facility.${index}.waitingPeriod`}
                                              mask={verifyPattern("Waiting Period")}
                                              isRequired={verifyRequired("Waiting Period")}
                                              component={verifyComponent("Waiting Period")}
                                              options={verifyOptions("Waiting Period")}
                                              value={values.facility[index]?.waitingPeriod}
                                              searchList={searchList}
                                              onChange={(e) => {
                                                if(e.includes("-") || isNaN(Number(e))) {
                                                  setFieldValue(`facility.${index}.waitingPeriod`, values.facility[index]?.tenor);
                                                  return;
                                                }

                                                setSearch("Waiting Period", index);
                                                setFieldValue(`facility.${index}.waitingPeriod`, e);
                                                if (!values.facility[index]?.waitingPeriod || verifyComponent("Waiting Period") != SearchField) {
                                                  return;
                                                }
                                                searchRequest(e, "Waiting Period");
                                              }}
                                              onFocus={(e) => {
                                                setSearchList([]);
                                              }}
                                              onSearchSelect={(e) => {
                                                setSearch("Waiting Period", index, e);
                                                setSearchList([]);
                                              }}
                                            />
                                          </Col>
                                          <Col md={index != values.facility.length - 1 ? 3 :4 } hidden={verifyVisiblity("Commitment Fee")} >
                                            {verifyField('Commitment Fee') &&
                                              <Field
                                                type="text"
                                                label="Commitment Fee"
                                                name={`facility.${index}.commitmentFee`}
                                                mask={verifyPattern("Commitment Fee")}
                                                isRequired={verifyRequired("Commitment Fee")}
                                                component={verifyComponent('Commitment Fee')}
                                                options={verifyOptions('Commitment Fee')}
                                                value={values.facility[index]?.commitmentFee}
                                                searchList={searchList}
                                                onChange={(e) => {
                                                  setSearch("Commitment Fee", index);
                                                  setFieldValue(`facility.${index}.commitmentFee`, e || 0);
                                                  if (!values.facility[index]?.commitmentFee || verifyComponent('Commitment Fee') != SearchField) {
                                                    return;
                                                  }
                                                  searchRequest(e, "Commitment Fee");
                                                }}
                                                onFocus={(e) => {
                                                  setSearchList([]);
                                                }}
                                                onSearchSelect={(e) => {
                                                  setSearch("Commitment Fee", index, e);
                                                  setSearchList([]);
                                                }}
                                              />
                                            }
                                          </Col>
                                            <Col md={1} style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                             {index !== 0 && ( 
                                                <AddButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); arrayHelpers.remove(index)}}>
                                                  <Icon name="trash"/>
                                                </AddButton>
                                              )}
                                            {index != values.facility.length - 1 ? <></> :
                                              (
                                                <AddButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); 
                                                  if(values.facility[0].insuredLegalEntity && values.facility[0].insuredLegalEntity != "") {
                                                    arrayHelpers.push({ 
                                                      grossInsuredParticipation: "",
                                                      facilityName: "", informationInterest: "", transactionType: "",
                                                      maxLimitOfLiability: "", tenor: "", period: "", grossLoanMargin: 0,
                                                      netLoanMargin: 0, minimumRetainedPercentage: "", waitingPeriod: "", commitmentFee: 0, 
                                                      currency: "", insuredLegalEntity: values.facility[0].insuredLegalEntity, totalFacilityAmount: ""
                                                    });
                                                  } else mc.error('Insured Legal Entity field is mandatory to add a new facility')
                                                }}>
                                                  <Icon name="plus"/>
                                                </AddButton>
                                              )                                               
                                            } 
                                          </Col>
                                        </Row>
                                      </div>
                                    </>

                            </FormContainer>
                                  )
                                })
                              ) : "" /* <AddButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); arrayHelpers.push() }}>
                              <Icon name="plus"></Icon>
                            </AddButton> */
                            }
                          </>
                        )}
                        />
                        
                        


                  </> : null}
                {showFields.attachments ? <>
                  <FormContainer title="ATTACHMENTS">
                    <>

                      {verifyField('Document Type') ?
                        <Row >
                          <Col hidden={verifyVisiblity("Document Type")} md={5} sm={6} xs={5} >
                            <Field
                              name="documentType"
                              label="Document Type"
                              type="text"
                              mask={verifyPattern("Document Type")}

                              isRequired={verifyRequired("Document Type")}
                              component={verifyComponent('Document Type')}
                              options={verifyOptions('Document Type')}
                              value={values.documentType}
                              searchList={searchList}
                              onChange={(e) => {
                                setSearch("Document Type", 0);
                                setFieldValue('documentType', e);
                                if (!values.documentType || verifyComponent('Document Type') != SearchField) {
                                  return;
                                }
                                searchRequest(e, "Document Type");

                              }}
                              onFocus={(e) => {
                                setSearchList([]);
                              }}
                              onSearchSelect={(e) => {
                                setSearch("Document Type", 0, e);
                                setSearchList([]);
                              }}
                            />
                          </Col>
                          <Col hidden={verifyVisiblity("Document Type")} md={4} sm={6} xs={6} >
                            <ButtonContainer>
                              <PlaceHolder htmlFor="fileInput" >UPLOAD FILE</PlaceHolder>
                              <TagInput id="fileInput" /* value={file} */ type="file" multiple={false} onChange={(event) => {
                                setFile(event.target.files[0]);
                                if (!values.documentType) {
                                  mc.error("Please, specify the document type.");
                                  /* setFile(undefined);   */
                                  return;
                                }
                                if (!event.target.files[0]) {
                                  mc.error("Invalid file, please select a valid one.");
                                  /*  setFile(undefined);  */
                                  return;
                                }
                                loading.start();


                                let reader = new FileReader();
                                let fileR = event.target.files[0];
                                reader.onloadend = () => {
                                  let result = Buffer.from(reader.result).toString('base64');
                                  let e = values.attachments;
                                  let obj = {
                                    documentType: values.documentType,
                                    fileName: fileR.name,
                                    fileBase64: result,
                                    size: fileR.size,
                                    type: fileR.type
                                  };
                                  e.push(obj)
                                  console.log( 'obj.fileBase64',obj.fileBase64);
                                  loading.stop();
                                  /* setFile(undefined);   */

                                };
                                // convert binary data to base64 encoded string
                                //let result = new Buffer(bitmap).toString('base64');



                                reader.onerror = error => { loading.stop();/*  setFile(undefined); */ };
                                reader.readAsArrayBuffer(fileR);


                              }} /* console.log('arquivo', event.currentTarget.files[0]) */ />
                            </ButtonContainer>

                          </Col>
                          <Col md={3} sm={0} xs={0}></Col>
                        </Row>
                        : ''}

                      {verifyField('Attachments:') ?
                        <Row hidden={verifyVisiblity("Attachments:")}>
                          <Col md={12}>

                            <TagsList tags={values.attachments} removeTag={(a) => {
                              setFieldValue('attachments', values.attachments.filter(tag => values.attachments.indexOf(tag) !== a))
                            }}></TagsList>

                          </Col>
                        </Row>

                        : ''}


                    {!isClient && (
                      <Row hidden={verifyVisiblity("I confirm that all needed documents have been received.")}>
                      {verifyField("I confirm that all needed documents have been received.") ?
                        <>
                        <Col md={12} style={{padding: '0px 0px 0px 0px'}}>
                        <Row>

                            <Col md={5} sm={10} xs={10}>
                                <Label>
                                  <strong> I confirm that all needed documents have been received</strong>
                                </Label>
                            </Col>
                            <Col md={1} sm={2} xs={2}>
                                {/*     Utilizando o react-switch-> https://www.npmjs.com/package/react-switch */}
                                <BorderSwitch>
                                  <Switch
                                    height={27}
                                    width={53}
                                    checked={values.iConfirmThatAllNeededDocumentsHaveBeenReceived}
                                    onChange={(a) => { setFieldValue('iConfirmThatAllNeededDocumentsHaveBeenReceived', a) }}
                                    checkedIcon={false}
                                    uncheckedIcon={false}
                                    handleDiameter={20}
                                    offColor={Colors.WHITE}
                                    onColor={Colors.GRAY[6]}
                                    offHandleColor={Colors.GRAY[6]}
                                    onHandleColor={Colors.WHITE}
                                    />
                                </BorderSwitch>
                            </Col>
                              <Col md={3} sm={0} xs={0}></Col>
                              <Col md={3} sm={0} xs={0}></Col>
                          </Row>
                          </Col>
                        </>
                        : ''}
                    </Row>
                    )}

                    </>
                  </FormContainer>
                </> : null}

                {verifyField('Notes:') ?
                  <Col>

                    <Field
                      name="notes"
                      label="Notes"
                      type="text"
                      isRequired={verifyRequired("Notes:")}
                      value={values.notes}
                      onChange={e => {

                        setFieldValue(`notes`, e);
                      }}
                      component={TextField}

                    />
                  </Col>
                  : ''
                }



                <ButtonContainer>
                  <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                  <Button
                    style={{ marginLeft: "10" }}
                    type="submit"
                    primary
                    id="btnSubmit"
                  >Submit
                  </Button>
                </ButtonContainer>

              </Form>
            )}
          >
          </Formik>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard >
    </Layout >
  )
}